import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extensionFile'
})
export class ExtensionFilePipe implements PipeTransform {
  transform(fileName :any , args:any): any {
    console.log(args);
      if (fileName.endsWith(".zip")) {
        return "assets/images/zip.svg";
      } 
      else if (fileName.endsWith(".rar")){
        return "assets/images/rar.svg";
      }
      else if (fileName.endsWith(".png") || fileName.endsWith(".PNG")){
        return "assets/images/png.svg";
      }
      else if (fileName.endsWith(".PDF") || fileName.endsWith(".pdf")){
        return "assets/images/filePDF.svg";
      }
      else if (fileName.endsWith(".jpg") || fileName.endsWith(".jpag") || fileName.endsWith(".JPG")){
        return "assets/images/jpg.svg";
      }
      else if (fileName.endsWith(".doc") || fileName.endsWith(".docx")){
        return "assets/images/word.svg";
      }
      else if (fileName.endsWith(".xls") || fileName.endsWith(".xlsx")){
        return "assets/images/excel.svg";
      } else {
        return "assets/images/fileDownload.svg";
      }
  }

}
